export const isValidOptionalPhone = (phone?: string | null) => !phone || phone.length === 10;
